<template>
    <div>
        <div class="modal-button">
             <el-button
                size="mini"
                type="danger"
                style="width: 92px"
                @click="dialogTableVisible = true"
                >
                Удалить
                </el-button>
        </div>
        <el-dialog title="Подтвердите действие" :visible.sync="dialogTableVisible">

            <span class="title-modal">Вы действительно хотите удалить тему?</span>

            <span slot="footer" class="dialog-footer">

                <el-button
                    size="mini"
                    @click="dialogTableVisible = false"
                    >
                    Отменить
                </el-button>

                <el-button
                    size="mini"
                    type="danger"
                    @click="organizationDeleteContact"
                    :loading="loading"
                    >
                    Удалить
                </el-button>
            </span>

        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogTableVisible: false,
            loading: false
        }
    },
    props: {
        index: {
            default: null,
            type: Number
        },
        id: {
            default: null,
            type: String
        }
    },
    methods: {
        async organizationDeleteContact() {
            this.loading = true
            try {
                await this.$store.dispatch('userRequestDelete', {
                    index: this.index,
                    id: this.id
                })
                this.dialogTableVisible = false
            } catch(e) {
                this.$ErrorsMod(e)
            }
            this.loading = false
        }
    }
}
</script>

<style scoped>
    .modal-button {
        margin-left: 20px;
    }
</style>
